import { FC } from 'react'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined'
import { MainLayout } from 'views/layouts'
import {
  ModuleKpi,
  ModuleKpiAction,
  ModuleKpiContent,
  ModuleKpiGrid,
  ModuleKpiIcon,
  ModuleKpiLink,
  ModuleKpiTitle,
  ModulesPageHeader,
} from 'views/screens/Modules/styled'

const Home: FC = () => {
  return (
    <MainLayout>
      <ModulesPageHeader>
        <h2>Configuración de textos de Betesa Premium corporativo</h2>
      </ModulesPageHeader>

      <ModuleKpiGrid>
        <ModuleKpiLink to="/modules/talents/texts/generals">
          <ModuleKpi>
            <ModuleKpiIcon tone="pink">
              <ArticleOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Generales</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/talents/texts/alert-level">
          <ModuleKpi>
            <ModuleKpiIcon tone="amber">
              <NotificationsActiveOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Nivel de alerta</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>

        <ModuleKpiLink to="/modules/talents/texts/quadrant">
          <ModuleKpi>
            <ModuleKpiIcon tone="violet">
              <GridViewOutlinedIcon fontSize="small" />
            </ModuleKpiIcon>
            <ModuleKpiContent>
              <ModuleKpiTitle>Textos por cuadrante</ModuleKpiTitle>
              <ModuleKpiAction>Configurar →</ModuleKpiAction>
            </ModuleKpiContent>
          </ModuleKpi>
        </ModuleKpiLink>
      </ModuleKpiGrid>
    </MainLayout>
  )
}

export default Home
